import i18n from "@/i18n";

const importanceItems = [
    {
        code: 'NOT_RELEVANT',
        title: '',
        index: ''
    },
    {
        code: 'UNIMPORTANT',
        title: i18n.global.t('importance.unimportant'),
        index: 1
    },
    {
        code: 'SOME_IMPORTANCE',
        title: i18n.global.t('importance.someImportance'),
        index: 2
    },
    {
        code: 'IMPORTANT',
        title: i18n.global.t('importance.important'),
        index: 3
    },
    {
        code: 'VERY_IMPORTANT',
        title: i18n.global.t('importance.veryImportant'),
        index: 4
    },
    {
        code: 'MATTER_OF_THE_HEART',
        title: i18n.global.t('importance.matterOfHeart'),
        index: 5
    },
]

export function getImportanceItem(code) {
    return importanceItems.filter(item => item.code === code)[0];
}